import { render } from "./vueBridge.vue?vue&type=template&id=fbec2e92&scoped=true"
import script from "./vueBridge.vue?vue&type=script&lang=js"
export * from "./vueBridge.vue?vue&type=script&lang=js"

import "./vueBridge.vue?vue&type=style&index=0&id=fbec2e92&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbec2e92"]])

export default __exports__